// Jedini izvor istine za tiptap šemu dokumenata. Koriste je DocumentEditor
// (pisanje) i testovi (round trip). Namjerno bez Image/Youtube/VideoNode —
// ugovor nema multimediju.
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
import { PlaceholderToken } from "./placeholder-node";

export const documentExtensions = [
  StarterKit.configure({ heading: { levels: [2, 3] }, link: false, underline: false, codeBlock: false }),
  Underline,
  Link.configure({ HTMLAttributes: { rel: "noopener noreferrer", target: "_blank" } }),
  PlaceholderToken,
];
